export let API_URL: string;

if (process.env.NODE_ENV === "production") {
  API_URL = "https://api.pricebroseq.com";
} else {
  API_URL = "https://localhost:7270";
  //API_URL = 'https://pricebrosdataapi.azurewebsites.net';
}

export const getAuthHeader = () => {
  return {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("PriceBrosToken")}`,
    },
  };
};
export const getPDFAuthHeader = () => {
  return {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("PriceBrosToken")}`,
    },
    responseType: "blob" as "text",
  };
};
